<script setup>
import { computed, inject } from 'vue';

const props = defineProps({
    modelValue: {
        type: String,
        default: undefined
    },
    value: {
        type: String,
        default: undefined
    },
    label: {
        type: String
    },
    disabled: {
        type: Boolean,
        default: false
    }
});

const { checked, busy } = inject('checkboxGroup');

const checkboxValue = computed(() => props.value ?? props.modelValue);
const isChecked = computed(() => checked.value.includes(checkboxValue.value));
</script>

<template>
    <label :disabled="disabled" class="custom-checkbox">
        <input
            type="checkbox"
            v-model="checked"
            :value="checkboxValue"
            :checked="isChecked"
            :disabled="busy || disabled"
        >
        <span class="custom-checkbox__label">{{ label }}</span>
    </label>
</template>
